export default "__VITE_PUBLIC_ASSET__4708e847__"